import React from 'react';
import CustomFields from "../../CustomFields/CustomFields";
import { HBox, withFormControl } from "puzzle";
import { CUSTOM_ATTRIBUTES, CUSTOM_FIELD } from "../../../Types";
import _ from 'lodash';

export class CustomFieldsPopup extends CustomFields {
  static defaultProps = {
    moduleName: 'CustomFields',
    moduleId: 'CustomFieldsPopup'
  };

  /**
   * inheritDoc
   */
  getData = (): CUSTOM_FIELD[] => {
    const { fieldsData } = this.state;
    const formData = this.props.form.getData();
    const parsedData: CUSTOM_FIELD[] = Object.keys(fieldsData).reduce((accumulator: CUSTOM_FIELD[], name: string) => {
      if (formData[name]) {
        accumulator.push({
          name,
          value: formData[name].trim()
        });
      }
      return accumulator;
    }, []);
    return parsedData;
  };

  /**
   * @inheritDoc
   */
  setPopupData = (data: CUSTOM_ATTRIBUTES[]) => {
    setTimeout(this.setData.bind(this, data), 0);
  };

  /**
   * Check if data has change from initial value
   * @param initValues
   */
  hasDataChange = (initValues: CUSTOM_ATTRIBUTES[]) => {
    return !_.isEqual(initValues, this.getData())
  };

  renderBody() {
    const { fields } = this.state;
    const { getFields, handleChange } = this.props.form;
    const { isTemplate } = this.props.customFieldsProps;
    const fieldsData = getFields();


    return !!fields.length && (
      <HBox className={'pd-custom-fields-wrap'} wrap>
        {fields.map(this.createCustomField.bind(this, isTemplate, handleChange, fieldsData))}
      </HBox>
    );
  }
}

export default withFormControl({}, false)(CustomFieldsPopup);
